import { Menu, Transition } from "@headlessui/react";
import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { FiMenu } from "react-icons/fi";
import { IoDownloadOutline, IoSearch } from "react-icons/io5";
import { LuMoreVertical } from "react-icons/lu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppContext from "../../context/AppContext";
import FilterSelect from "../common/FilterSelect";
import FieldListModal from "./FieldStaffListModal";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import MapView from "../../assets/map-sharp.png";
import createImg from "../../assets/Vector (6).png";
import importImg from "../../assets/arrow-undo-circle.png";
import DeletePermission from "../suspence/DeletePermission";
import { fetchFilterExcel } from "../../service/Task";
import {
  deleteTasks,
  putTasksOnHold,
  fetchFieldAgentMap,
  deleteAllRecords,
  unassignTask,
} from "../../service/Task";
import { SubActivity } from "../common/task/SubActivity";
import { FaCirclePause, FaRepeat, FaUser } from "react-icons/fa6";
import { MdDelete, MdOutlineDeleteOutline } from "react-icons/md";
import { fetchTasks } from "../../service/Task";
import Modal from "../DownloadModal/Modal";
import Joyride from "react-joyride";
import translations from "../common/Translations";
import ReAssignModal from "./ReAssignModal";
import { TbUserCancel } from "react-icons/tb";
import CommonButton from "../common/CommonButton";
import ActivitySelect from "../common/task/ActivitySelect";
import { getActivityListByProjectId } from "../../service/User";
import upload from "../../assets/upload.png"
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const TaskListToolbar = ({
  openTab,
  setOpenTab,
  isChecked,
  selectedtask,
  setIsChecked,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  setselectedtask,
  finishedStatus
}) => {
  const [open, setOpen] = useState(false);
  const [openReassign, setOpenReassign] = useState(false);
  const navigate = useNavigate();
  const context = useContext(AppContext);
  const {
    setPriority,
    setActive,
    selectAll,
    setAreaCode,
    areaCode,
    accountNo,
    setAccountNo,
    setFieldAgentList,
    fieldAgentList,
    setSelectedUserId,
    workflowId,
    priority,
    active,
    taskData,
    setTaskData,
    selectedOrgId,
    setSelectedOrgId,
    setSelectedOrgName,
    langMode,
    tasktollbar,
    runTour,
    key,
    userType,
    selectedUserName,
    setSelectedUserName,
    setWorkflowName,
    workflowName,
    activityId,
    projectId, activityLoader
  } = context;
  const [selectedStatusName, setselectedStatusName] = useState("Select Status");
  const [selectedPriorityName, setselectedPriorityName] =
    useState("Select Priority");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState("");
  const [deleteItemType, setDeleteItemType] = useState("");
  const [downloadModal, setDownloadModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Loader state
  const location = useLocation(); // Get the current route
  const [unassign, setUnassign] = useState(false);
  const [assigneeId, setAssigneeId] = useState();
  const [inputValue, setInputValue] = useState(""); // Temporary state for input
  const [selectItemColor, setSelectItemColor] = useState("");
  const [selectItemColor1, setSelectItemColor1] = useState("");
  const [selectItemColor2, setSelectItemColor2] = useState("");
  const [areainputValue, setAreaInputValue] = useState(""); // Temporary state for input
const [activity, setActivity] = useState([])
  const [isLoader, setLoader] = useState(false)

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
  };
  const getLabelMarginLeft = (priority) => {
    switch (priority) {
      case "Default":
        return "165px";
      case "Low_Priority":
        return "165px";
      case "Medium_Priority":
        return "165px";
      case "High_Priority":
      default:
        return "165px";
    }
  };

  const getLabelMarginLeft2 = (status) => {
    switch (status) {
      case "Default":
        return "44px";
      case "Active":
        return "45px";
      case "Assigned":
        return "49";
      case "In_Progress":
        return "46px";
      case "Completed":
        return "45px";
      case "On_Hold":
        return "45px";
      default:
        return "44px";
    }
  };

  const getLabelMarginLeft3 = (selectedUserName) => {
    switch (selectedUserName) {
      default:
        return "230px";
    }
  };

  useEffect(() => {
    const savedSearch = sessionStorage.getItem("taskSearchValue");
    if (savedSearch) {
      setAccountNo(savedSearch);
      setInputValue(savedSearch)
    }
  }, []);

  useEffect(() => {
    // Select the <main> tag
    const mainElement = document.querySelector('main');

    // Check if the element exists before adding a class
    if (mainElement) {
      mainElement.classList.add('w-full');
    }

    // Cleanup function to remove the class when the component unmounts
    return () => {
      if (mainElement) {
        mainElement.classList.remove('w-full');
      }
    };
  }, [activity]);

  const { theme } = useContext(AppContext);
  const priorityoptions = [
    { id: "Everything", value: "Default" },
    { id: "Low_Priority", value: "Low Priority" },
    { id: "Medium_Priority", value: "Medium Priority" },
    { id: "High_Priority", value: "High Priority" },
  ];
  const activeoptions = [
    { id: "Everything", value: "Default" },
    { id: "Active", value: "Active" },
    { id: "Assigned", value: "Assigned" },
    { id: "In_Progress", value: "In Progress" },
    { id: "Completed", value: "Completed" },
    { id: "On_Hold", value: "On Hold" },
  ];
  const handleShowModal = () => {
    // if(!isChecked){
    //   toast.warn("Select atleast one Task");
    // }else{
      if (!activityId) {
        toast.warn(translations[langMode].selectWorkflowFirst);
        return;
      }
      setDownloadModal(true);
    // }
  };
  const showDeleteModal = (type, id) => {
    if (!activityId) {
      toast.warn(translations[langMode].selectWorkflowFirst);
      return;
    }
    setDeleteItemType(type);
    setDeleteItemId(id);
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };
  const resetFilters = () => {
    setPriority("Default");
    setActive("Default");
    setSelectedUserId("");
    setSelectedUserName("Default");
    // setSelectedOrgName("");
    setSelectedOrgId("");
    setSelectItemColor("");
    setSelectItemColor1("");
    setSelectItemColor2("");
  };

  const handleSetMapListFilters = (key, value) => {
    try {
      let mapListData = Cookies.get("mapListFilters");
      mapListData = mapListData ? JSON.parse(mapListData) : {};

      mapListData[key] = value;

      Cookies.set("mapListFilters", JSON.stringify(mapListData));
    } catch (error) {
      console.error("Error updating mapListFilters cookie:", error);
    }
  }

  const handlePrioritySelection = (selectedValue) => {
    const selectedOption = priorityoptions.find(
      (option) => option.value === selectedValue
    );
    if (selectedOption) {
      setselectedPriorityName(selectedOption.value);
      setSelectItemColor1(theme === "dark" ? "white" : "black");
      setPriority(
        selectedOption.id === "Priority" ? "Default" : selectedOption.id
      );
      handleSetMapListFilters("selectedPriority", selectedOption.id)
    }
  };

  const handleStatusSelection = (selectedValue) => {
    const selectedOption = activeoptions.find(
      (option) => option.value === selectedValue
    );
    if (selectedOption) {
      setselectedStatusName(selectedOption.value);
      setSelectItemColor(theme === "dark" ? "white" : "black");
      setActive(selectedOption.id === "Status" ? "Default" : selectedOption.id);
      handleSetMapListFilters("selectedStatus", selectedOption.id)
    }
  };

  const handleUnassign = async () => {
    try {
      const payload = {
        workflowId : activityId,
        taskIds: selectedtask, // Should be an array of task IDs
        ...(assigneeId && { assigneeId }), // Include assigneeId only if it's defined
      };

      console.log("Payload being sent:", payload, selectedtask, assigneeId); // Debug log
      const data = await unassignTask(payload); // Pass the payload

      if (data.header.code === 600) {
        toast.success("Task unassigned successfully!");
        setIsChecked(false);
        handleCloseDeleteModal();

        // const updatedTaskData = taskData.map((task) => {
        //   if (selectedtask.includes(task.taskId)) {
        //     return {
        //       ...task,
        //       taskStatus: "Active", // Update task status
        //       isChecked: false, // Uncheck the task
        //     };
        //   }
        //   return task; // No change for other tasks
        // });

        // setTaskData(updatedTaskData);
        fetchTasks({
          workflowIds: activityId,
          currentPage: 1,
          pageSize: 10,
          priority: "Priority",
          active: "Status",
        }).then((fetchedTasks) => {
          console.log("Fetched tasks:", fetchedTasks);
          // Update taskData with the new fetched tasks
          setTaskData(fetchedTasks.taskList);
          setActive("Active");
          setPriority("Priority");
          setselectedStatusName("Status");
          setselectedPriorityName("Priority");
          setSelectedUserId("");
          setSelectedUserName("Default");
        });
      } else {
        toast.error(
          data.body?.error || "An error occurred while unassigning the task."
        );
      }
    } catch (error) {
      console.error("Failed to unassign task:", error);
      toast.error("An error occurred while unassigning the task.");
    }
  };

  const taskDeleteList = async () => {
    try {
      const data = await deleteTasks(selectedtask);
      setIsChecked(false);
      setOpen(false);
      if (selectAll) {
        handleCloseDeleteModal();
        const updatedTaskData = taskData.filter(
          (task) => !selectedtask.includes(task.taskId)
        );
        setTaskData(updatedTaskData);
      } else {
        toast.success("Task deleted successfully");
        const updatedTaskData = taskData.filter(
          (task) => !selectedtask.includes(task.taskId)
        );
        setTaskData(updatedTaskData);
        handleCloseDeleteModal();
      }
    } catch (error) { }
  };

  const handleAreaCodeChange = (event) => {
    setAreaInputValue(event.target.value);
    handleSetMapListFilters("areaInput", event?.target?.value)
  };


  useEffect(() => {
    const storedPriority = Cookies.get("mapListFilters");
    if (storedPriority) {
      const parsedPriority = JSON.parse(storedPriority);

      setselectedPriorityName(parsedPriority?.selectedPriority);
      setselectedStatusName(parsedPriority?.selectedStatus);
      setAreaInputValue(parsedPriority?.areaInput)

      if (Array.isArray(priorityoptions)) {
        const selectedOption = priorityoptions.find(
          (option) => option.value === parsedPriority?.selectedPriority
        );
        if (selectedOption) {
          setSelectItemColor1(theme === "dark" ? "white" : "black");
        }

      }
      if (Array.isArray(fieldAgentList)) {
        const selectedAgent = (fieldAgentList || [])?.find(
          (agent) => agent.userId === parsedPriority?.selectedUserId
        );
        if (selectedAgent) {
          setSelectedUserName(selectedAgent.name);
        }
      }
    }

  }, [priorityoptions, theme, fieldAgentList]);


  window.onload = () => {
    Cookies.remove("mapListFilters");
    setselectedPriorityName("Select Priority");
    setPriority("Priority");
    setselectedStatusName("Select Status");
    setActive("Status");
    setSelectedUserId("")
    setAreaCode("")
    setSelectedUserName(0)

    sessionStorage.removeItem("taskSearchValue")
    setAccountNo("");
    setInputValue("")

    sessionStorage.removeItem("from_Date")
    setFromDate("")

    sessionStorage.removeItem("to_Date")
    setToDate("")

  }
  const handleInputChange = (event) => {
    setInputValue(event.target.value); // Update temporary state
  };

  const handleSearch = () => {
    setAccountNo(inputValue); // Set the final value on search
    sessionStorage.setItem("taskSearchValue", inputValue); // Save value in sessionStorage
  };

  const handleAreacodeSearch = () => {
    setAreaCode(areainputValue);
  };

  useEffect(() => {
    if (areainputValue?.length === 0) {
      handleAreacodeSearch();
    }
  }, [areainputValue]);
  useEffect(() => {
    if (inputValue?.length === 0) {
      handleSearch();
    }
  }, [inputValue]);

  useEffect(() => {
    const fetchFieldAgents = async () => {
      try {
        const agents = await fetchFieldAgentMap(selectedOrgId);
        setFieldAgentList(agents.body.value);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    };
    fetchFieldAgents();
  }, [selectedOrgId]);

  useEffect(() => { }, [fieldAgentList]);

  const handleAssigneeChange = (selectedId) => {
    setSelectedUserId(selectedId);
    handleSetMapListFilters("selectedUserId", selectedId)
    const selectedAgent = fieldAgentList.find(
      (agent) => agent.userId === selectedId
    );
    if (selectedAgent) {
      setSelectedUserName(selectedAgent.name);
      setAssigneeId(selectedAgent.userId);
      setSelectItemColor2(theme === "dark" ? "white" : "black");
    } else if (selectedId === "") {
      setSelectedUserName("Default");
    }
  };

  const handleDeleteAllRecord = async (workflowId) => {
    try {
      setLoader(true)
      const responseData = await deleteAllRecords(workflowId);
      if (responseData.header.code === 600) {
        const updatedTaskData = taskData.includes((task) => task.workflowId);
        setTaskData(updatedTaskData);
        toast.success("All records are deleted");
        setLoader(false)
        handleCloseDeleteModal();
      } else {
        setLoader(false)
        throw new Error(responseData.header.message);
      }
    } catch (error) {
      setLoader(false)
      console.error("Error:", error.message);
      toast.error("Error: " + error.message);
    }
  };

  const handleTabChange = (tab) => {
    setOpenTab(tab);
    localStorage.setItem("activeTab", tab);
  };

  const downloadFiltration = async (selectedOption) => {
    setIsLoading(true);
    try {
      const userTypeCookie = Cookies.get("userType");
      const params = {
        workflowIds: activityId || "",
        priority: priority || "",
        active: active || "",
        areaCode: areaCode || "",
        accountNo: accountNo || "",
        organizationId: "",
        projectId: projectId || ""
      };

      // if (selectedOption === "all" && userTypeCookie === "super_admin") {
      //   params.organizationId = selectedOrgId || "";
      //   params.workflowIds = "";
      // } else if (
      //   selectedOption === "particular" ||
      //   userTypeCookie !== "super_admin"
      // ) {
      //   params.organizationId = "";
      // } else if (selectedOption === "all" || userTypeCookie !== "super_admin") {
      //   params.workflowIds = "";
      // }
      const orgId = JSON.parse(localStorage.getItem("selectedOrgId"))
      if (selectedOption === "all") {
        // if (userTypeCookie === "super_admin") {

          params.organizationId = orgId || "";
          params.workflowIds = "";

        // } else {
        //   params.organizationId = "";
        //   params.workflowIds = "";
        // }
      } else if (
        selectedOption === "particular" ||
        userTypeCookie !== "super_admin"
      ) {
        params.organizationId = selectedOrgId || "";

        params.workflowIds = activityId || "";

      }
      const data = await fetchFilterExcel({
        workflowIds: params.workflowIds,
        priority: params.priority,
        active: params.active,
        areaCode: params.areaCode,
        accountNo: params.accountNo,
        organizationId: params.organizationId,
        projectId: params.projectId,
        includeProjectId: selectedOption === "all"
      });
      const code = data.header?.code;
      if (code === 600) {
        const s3Link = data.body?.value;
        const link = document.createElement("a");
        link.href = s3Link;
        link.setAttribute("download", "report.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Excel is downloading");
      } else {
        toast.error("No records found");
      }
    } catch (error) {
      console.error("Error during report download:", error);
      toast.error("An error occurred while downloading the report.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleMapView = () => {
    resetFilters();
    navigate("/maptask");
  };

  const handleGoCsv = () => {
    Cookies.set("viewMode", "list");
    resetFilters();
    navigate("/task/import-csv");
  };
  const handleGoCreateTask = () => {
    Cookies.set("viewmode", "list");
    resetFilters();
    navigate("/task/create-task");
  };
  const handleTaskHold = async (selectedtask) => {
    let uniqueTasks = Array.from(new Set(selectedtask));
    try {
      const response = await putTasksOnHold(uniqueTasks);
      if (response.header.code === 600) {
        toast.success("Task on hold");

        fetchTasks({
          workflowIds: activityId,
          currentPage: 1,
          pageSize: 10,
          priority: "Priority",
          active: "Status",
        }).then((fetchedTasks) => {
          console.log("Fetched tasks:", fetchedTasks);
          // Update taskData with the new fetched tasks
          setTaskData(fetchedTasks.taskList);
          setActive("Status");
          setPriority("Priority");
          setselectedStatusName("Status");
          setselectedPriorityName("Priority");
          setSelectedUserId("");
          setSelectedUserName("Default");
        });
        uniqueTasks = [];
      } else {
        toast.error("Not able to make task on hold");
      }
    } catch (error) {
      console.error("Error putting tasks on hold:", error);
    }
  };
  // useEffect(() => {
  //   setAccountNo(""); // Reset account number
  //   sessionStorage.removeItem("taskSearchValue"); // Clear session storage on route change
  // }, [location.pathname]); // Run only on route change

  // Retrieve saved account number when the component mounts
  useEffect(() => {
    const savedValue = sessionStorage.getItem("taskSearchValue");
    if (savedValue) {
      setAccountNo(savedValue);
    }
  }, []);

  const handleClick = () => {
    if (!isChecked) {
      toast.error("Please select a task before proceeding!");
    }
  };

//activity
  useEffect(() => {
    const fetchActivityList = async () => {
          // if (!projectId?.length > 0) return; // Don't fetch if there's no organization selected

      try {
        const data = await getActivityListByProjectId(projectId);
            setActivity(data)
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };
    if (projectId !== null) {
      fetchActivityList(); // Trigger the project fetch whenever `userInfo.organization` changes
    }
  }, [projectId]);
  
  const defaultActivityValue = useMemo(() => {
    if (projectId !== null && activityId && activity?.length) {
      const activityIdList = typeof activityId === 'string'
        ? activityId.split(',')
        : Array.isArray(activityId)
          ? activityId.map(id => id.toString())
          : [activityId?.toString()];

      return (activity || [])
        .filter((org) => activityIdList.includes(org.workflowId?.toString()))
        .map((dept) => ({
          value: dept.workflowId,
          label: dept.workflowName,
        }));
    }
    return [];
  }, [projectId, activityId, activity]);


  return (
    <>
      <Joyride
        steps={tasktollbar}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        scrollToFirstStep
        styles={{
          options: {
            arrowColor: "#fff",
            zIndex: 10000,
            overlayColor: "rgba(0, 0, 0, 0.5)",
            primaryColor: "#4C3BCF",
            textColor: "#333",
          },
          tooltip: {
            borderRadius: "10px",
            transition: "transform 0.3s ease, opacity 0.3s ease",
          },
          buttonSkip: {
            color: "#4C3BCF",
          },
          buttonNext: {
            backgroundColor: "#4C3BCF",
            transition: "background-color 0.3s ease",
          },
          buttonBack: {
            color: "#4C3BCF",
          },
          spotlight: {
            transition: "box-shadow 0.5s ease",
          },
        }}
      />
      <div className="flex flex-col">
        <div className={`flex xsm:flex-row flex-col  gap-y-3 justify-between lg:items-center items-start ${langMode === 'ar' ? 'lg:pl-14' : 'lg:pr-14'}  xl:pr-0 mb-4`}>
          <div className="flex gap-[13px] sm:flex-row flex-col">
            <div className="mr-2 md:mr-0 flex rounded-md md:gap-[6px] w-fill">
              <button
                onClick={handleMapView}
                className={`py-[5px] px-4 bg-[#FFF] h-[32px] text-[#97A4B7] text-md ${langMode === 'ar' ? 'rounded-r-[16px] ' : 'rounded-l-[16px]'}  font-semibold transition-all duration-300 ${theme === "dark"
                  ? " bg-blue-800  "
                  : theme === "high-contrast"
                    ? "bg-black "
                    : ""
                  }`}
              >
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.0813 5.6259L7.90625 1.67578L1.375 6.1875V20.625L7.91871 16.3741L14.0938 20.3242L20.625 15.8125V1.375L14.0813 5.6259ZM13.4062 18.0898L8.59375 14.9961V3.91016L13.4062 7.00391V18.0898Z" fill="#97A4B7" />
                </svg>
              </button>
              <button
                className={`py-[4px] px-4 h-[32px] bg-[#236DB4] text-[#FFFFFF] text-md  font-semibold transition-all duration-300 mr-1  ${langMode === 'ar' ? 'rounded-l-[16px] ' : 'rounded-r-[16px]'}  ${theme === "dark"
                  ? "dark-mode  "
                  : theme === "high-contrast"
                    ? "high-contrast  "
                    : ""
                  }`}
              >
                <FiMenu size={24} />
              </button>
            </div>
            {!activityLoader && 
            <div className="w-fit">
            <ActivitySelect setWorkflowName={setWorkflowName}
              workflowName={workflowName}
              selectedOrgId={selectedOrgId}
              showPlaceholder={true}
              placeholder={translations[langMode].Activities}
              optionData={projectId !== null ? activity : []}
              defaultValue={defaultActivityValue}
              height="32px"
            />
            </div>}

          </div>
          <div className="flex flex-row items-center gap-4 ml-4">
            <CommonButton onClick={handleShowModal} className="createTask !rounded-[4px] bg-[#FF9F29] !text-[#FFFFFF] !py-2 !px-3 !gap-[5px] !h-[32px]">
              <IoDownloadOutline size={22} className="text-white" />
            </CommonButton>
            <CommonButton onClick={handleGoCreateTask} className="createTask !rounded-[4px] bg-[#E32527] !text-[#FFFFFF] !py-2 !px-3 !gap-[5px] !h-[32px]">
              <img src={createImg} className="max-w-[22px] max-h-[22px]" alt="create tmg" />
            </CommonButton>
            <CommonButton onClick={handleGoCsv} className="gocsvs !rounded-[4px] bg-[#236DB4] !py-2 !px-3 !gap-[5px] !h-[32px] w-fit">
              <img src={upload} className="h-4 max-w-[22px] max-h-[22px]" alt="upload" />
            </CommonButton>
            <Menu as="div" className={`relative mr-3`} >
              <div>
                <button className="relative bottom-1 h-full mt-[7px]"
                // disabled={!(selectedtask.length > 0)}
                >
                  <Menu.Button
                    className={`relative border-gray-800 text-black border flex rounded-md p-[4px] max-h-[30px] text-md h-9 ${
                      theme === "dark"
                        ? "dark-mode border-white text-white border-2"
                        : theme === "high-contrast"
                        ? "bg-yellow-300 border-black text-black"
                        : "bg-white "
                    }`}
                  >
                    <span />
                    <LuMoreVertical
                      size={20}
                      className={`${
                        theme === "dark"
                          ? "text-white"
                          : theme === "high-contrast"
                          ? "text-black"
                          : "text-black"
                      }`}
                    />
                  </Menu.Button>
                </button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items
                  className={` ${
                    theme === "dark"
                      ? "dark-mode border "
                      : theme === "high-contrast"
                      ? "high-contrast  "
                      : ""
                  } absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-lg bg-white py-1 shadow-md ring-1
                 ring-black ring-opacity-5 focus:outline-none`}
                >
                  <Menu.Item
                    className={` ${
                      theme === "dark"
                        ? "dark-mode hover:text-indigo-700 "
                        : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                    }`}
                  >
                    {({ active }) => (
                      <Link
                        to=""
                        className={classNames(
                          active ? "bg-gray-100" : "",
                          "flex px-4 py-2 text-sm text-gray-700 gap-4 items-center text-nowrap",
                          finishedStatus === "Finished" ? "hidden" : ""
                        )}
                        onClick={() => setOpen(true)}
                      >
                        <FaUser className="w-5" />
                        {translations[langMode].assign}
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item
                    className={` ${
                      theme === "dark"
                        ? "dark-mode hover:text-indigo-700 "
                        : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                    }`}
                  >
                    {({ active }) => (
                      <Link
                        to=""
                        className={classNames(
                          active ? "bg-gray-100" : "",
                          "flex px-4 py-2 text-sm text-gray-700 gap-4 items-center text-nowrap",
                           finishedStatus === "Finished" ? "hidden" : ""
                        )}
                        onClick={() => setOpenReassign(true)}
                      >
                        <FaRepeat className="w-5" />
                        {translations[langMode].reassign}
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item
                    className={` ${
                      theme === "dark"
                        ? "dark-mode hover:text-indigo-700 "
                        : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                    }`}
                  >
                    {({ active }) => (
                      <Link
                        to=""
                        className={classNames(
                          active ? "bg-gray-100" : "",
                          "flex px-4 py-2 text-sm text-gray-700 gap-4 items-center text-nowrap",
                           finishedStatus === "Finished" ? "hidden" : ""
                        )}
                        onClick={() => {
                          setUnassign(true);
                          setDeleteModalOpen(true);
                        }}
                      >
                        <TbUserCancel size={20} className="w-5" />
                        {translations[langMode].unassignn}
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item
                    className={` ${
                      theme === "dark"
                        ? "dark-mode hover:text-indigo-700 "
                        : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                    }`}
                  >
                    {({ active }) => (
                      <Link
                        to=""
                        className={classNames(
                          active ? "bg-gray-100" : "",
                          "flex px-4 py-2 text-sm text-gray-700  gap-4 items-center"
                        )}
                        onClick={() => handleTaskHold(selectedtask)}
                      >
                        <FaCirclePause className="w-5" />
                        {translations[langMode].onhold}
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item
                    className={` ${
                      theme === "dark"
                        ? "dark-mode hover:text-indigo-700 "
                        : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                    }`}
                  >
                    {({ active }) => (
                      <Link
                        to=""
                        className={classNames(
                          active ? "bg-gray-100" : "",
                          "px-4 py-2 text-sm text-gray-700 flex gap-4 items-center"
                        )}
                        onClick={() => showDeleteModal("single", null)}
                      >
                        <MdDelete className="w-5" />
                        {translations[langMode].delete}
                      </Link>
                    )}
                  </Menu.Item>
                  {(userType === "super_admin" || userType === "admin") && (
                    <Menu.Item
                      className={` ${
                        theme === "dark"
                          ? "dark-mode hover:text-indigo-700 "
                          : theme === "high-contrast"
                          ? "high-contrast  "
                          : ""
                      }`}
                    >
                      {({ active }) => (
                        <Link
                          to=""
                          className={classNames(
                            active ? "bg-gray-100" : "",
                            "flex px-4 py-2 text-sm text-gray-700 gap-4 items-center text-nowrap"
                          )}
                          onClick={() => showDeleteModal("all", activityId)} // Call the delete all function
                        >
                          <MdOutlineDeleteOutline className="w-5" />
                          {translations[langMode].deleteAllRecord}
                        </Link>
                      )}
                    </Menu.Item>
                  )}
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        </div>
        {/* <div className="flex flex-wrap flex-row gap-2 mb-5">
          <div
            className={` bg-white  ${theme === "dark"
              ? "dark-mode  "
              : theme === "high-contrast"
                ? "high-contrast  "
                : ""
              }`}
          >
            <div className="flex">
              <div className="relative mt-1">
                <input
                  id="account-search"
                  autoComplete="new-password" // Alternative to prevent autofill
                  type="text"
                  className={`block h-8 pt-2  text-sm text-gray-900 border border-gray-300  ${langMode === 'ar' ? 'rounded-l-md' : 'rounded-r-lg'} w-36
                   focus:ring-blue-300 focus:border-blue-300
                    ${theme === "dark"
                      ? "dark-mode  "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                    }`}
                  placeholder={translations[langMode].search}
                  value={inputValue} // Bind temporary state to input
                  onChange={handleInputChange} // Update temporary state on input change
                />
              </div>

              <button
                onClick={handleSearch} // Update state on button click
                className={`h-8 px-4 mt-1 bg-[#0074FF] text-white   ${langMode === 'ar' ? 'rounded-l-md' : 'rounded-r-md'}`}
              >
                <IoSearch size={20} />{" "}
              </button>
            </div>
          </div>

          <div
            className={` bg-white ${theme === "dark"
              ? "dark-mode  "
              : theme === "high-contrast"
                ? "high-contrast  "
                : ""
              }`}
          >   <div className="flex">
              <div className="relative mt-1">
                <input
                  id="account-search"
                  autoComplete="new-password" // Alternative to prevent autofill
                  type="text"
                  className={`block h-8 pt-2  text-sm text-gray-900 border border-gray-300 ${langMode === 'ar' ? 'rounded-r-md' : 'rounded-l-md'} w-44
               focus:ring-blue-300 focus:border-blue-300
                ${theme === "dark"
                      ? "dark-mode  "
                      : theme === "high-contrast"
                        ? "high-contrast  "
                        : ""
                    }`}
                  placeholder={translations[langMode].searchbycode}
                  value={areainputValue}
                  onChange={handleAreaCodeChange}
                />
              </div>

              <button
                onClick={handleAreacodeSearch} // Update state on button click
                className={`h-8 px-4 mt-1 bg-[#0074FF] text-white   ${langMode === 'ar' ? 'rounded-l-md' : 'rounded-r-md'}`}
              >
                <IoSearch size={20} />{" "}
              </button>
            </div>

          </div>
          <FilterSelect
            defaultText={translations[langMode].priority}
            options={priorityoptions}
            onChange={handlePrioritySelection}
            value={selectedPriorityName}
            selectItemColor1={selectItemColor1}
          />
          <FilterSelect
            defaultText={translations[langMode].status}
            options={activeoptions}
            onChange={handleStatusSelection}
            value={selectedStatusName}
            selectItemColor={selectItemColor}
          />

          <FilterSelect
            selectItemColor2={selectItemColor2}
            defaultText={translations[langMode].selectAssign}
            options={
              Array.isArray(fieldAgentList) && fieldAgentList.length > 0
                ? [
                  { id: "", value: "Default" },
                  ...fieldAgentList.map((agent) => ({
                    id: agent.userId,
                    value: agent.name,
                  })),
                ]
                : [{ id: "", value: "Default" }]
            }
            value={selectedUserName}
            onChange={(selectedName) => {
              if (selectedName === "Default") {
                handleAssigneeChange("");
              } else {
                const selectedAgent = fieldAgentList.find(
                  (agent) => agent.name === selectedName
                );
                if (selectedAgent) {
                  handleAssigneeChange(selectedAgent.userId);
                }
              }
            }}
          />
          <SubActivity />

          <div className="px-1  w-full md:w-36 mt-1">
            <div className="flex items-center">
              <input
                type="text"
                className={`text-sm form-input border  border-gray-400 rounded-md w-full h-8 ${theme === "dark"
                  ? "dark-mode border-gray-200 placeholder-white"
                  : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                  }`}
                value={fromDate ? formatDate(fromDate) : ""}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!e.target.value) {
                    e.target.type = "text";
                  }
                }}
                onChange={(e) => {
                  setFromDate(e.target.value);
                  sessionStorage.setItem("from_Date", e.target.value)
                }}
                placeholder={translations[langMode].fromdate}
              />
            </div>
          </div>

          <div className=" px-1 w-full md:w-36 mt-1">
            <div className="flex items-center">
              <input
                type="text"
                className={`text-sm form-input border  border-gray-400 rounded-md w-full h-8 ${theme === "dark"
                  ? "dark-mode border-gray-200 placeholder-white"
                  : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                  }`}
                value={toDate ? formatDate(toDate) : ""}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!e.target.value) {
                    e.target.type = "text";
                  }
                }}
                onChange={(e) => {
                  setToDate(e.target.value);
                  sessionStorage.setItem("to_Date", e.target.value)
                }}
                placeholder={translations[langMode].todate}
              />
            </div>
          </div>
        </div> */}
      </div>
      <FieldListModal
        taskData={taskData}
        setTaskData={setTaskData}
        open={open}
        setOpen={setOpen}
        selectedtask={selectedtask}
        setselectedtask={setselectedtask}
        setIsChecked={setIsChecked}
        selectedOrgId={selectedOrgId}
        resetFilters={resetFilters}
      />
      <ReAssignModal
        taskData={taskData}
        setTaskData={setTaskData}
        openReassign={openReassign}
        setOpenReassign={setOpenReassign}
        selectedtask={selectedtask}
        setIsChecked={setIsChecked}
        selectedOrgId={selectedOrgId}
        resetFilters={resetFilters}
        setselectedStatusName={setselectedStatusName}
        setselectedPriorityName={setselectedPriorityName}
      />
      {deleteModalOpen && deleteItemType === "all" && (
        <DeletePermission
          deleteFunction={() => handleDeleteAllRecord(deleteItemId)}
          onClose={handleCloseDeleteModal}
          isLoading={isLoader}
          onDeleteText="Are you sure you want to delete all records?"
        />
      )}
      {deleteModalOpen && deleteItemType === "single" && (
        <DeletePermission
          deleteFunction={taskDeleteList}
          onClose={handleCloseDeleteModal}
          onDeleteText="Are you sure you want to delete records?"
        />
      )}
      <Modal
        setDownloadModal={setDownloadModal}
        downloadModal={downloadModal}
        downloadFiltration={downloadFiltration}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      {deleteModalOpen && unassign && (
        <DeletePermission
          onDeleteText="Are you sure you want to unassign this tasks ?"
          onClose={handleCloseDeleteModal}
          deleteFunction={handleUnassign} // Ensure selectedTask is passed correctly
        />
      )}
    </>
  );
};
export default TaskListToolbar;
